import { Helmet } from 'react-helmet-async';

/** Imagem Open Graph padrão — usada quando a página não passa `ogImage`. */
const DEFAULT_OG_IMAGE = 'https://nexustech.tec.br/og-home.jpg';

/**
 * SeoHead — componente de metadados SEO centralizado.
 *
 * @param {string} title - Título da página (≤ 60 chars recomendado)
 * @param {string} description - Descrição para motores de busca (≤ 160 chars)
 * @param {string} canonical - URL canônica absoluta
 * @param {string} [ogImage] - URL da imagem Open Graph (default: DEFAULT_OG_IMAGE)
 * @param {object|Array} [jsonLd] - Dados estruturados Schema.org (objeto ou array)
 * @param {boolean} [noindex=false] - Emite `robots: noindex,follow` (páginas
 *   privadas/utilitárias como login). Não usar em página pública.
 */
const SeoHead = ({
  title,
  description,
  canonical,
  ogImage,
  jsonLd,
  noindex = false,
}) => {
  const image = ogImage || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,follow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SeoHead;
